import { render } from "./WCInputGroup.vue?vue&type=template&id=a4950980"
import script from "./WCInputGroup.vue?vue&type=script&lang=js"
export * from "./WCInputGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__